import React from 'react'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { StatusBadge } from '@mobi/component-library/Feedback/StatusBadge'

export const LiveStatusBadge = ({ badgeSize = 'S' }: StatusBadgeSize) => {
  return (
    <StatusBadge color='crimson' badgeSize={badgeSize}>
      <Icon name='SolidCircle' size='0.8rem' /> Live
    </StatusBadge>
  )
}
type StatusBadgeSize = Pick<React.ComponentProps<typeof StatusBadge>, 'badgeSize'>
